module.exports = __webpack_public_path__ + "img/16_Cabrilla española (P.humeralis).19c014e5.png";